/* <lt-delivery-estimate> — "Order now, delivery Oct 17 – 29" at the foot of
   the product page's features card (sections/main-product-bento.liquid,
   docs/product-bento.md).

   The dates are counted here, in the visitor's browser, and not in Liquid:
   a page rendered on the server sits in Shopify's cache, so a date written
   into it goes stale. The rule is the shipping policy's (owner,
   2026-10-14): an order placed before the cutoff hour, Warsaw time, on a
   business day counts from that day, any other order from the next business
   day; delivery is `data-min-days` to `data-max-days` business days later.
   Business days are Monday to Friday; public holidays are not known here.

   The element ships `hidden` and shows itself only once the text is set, so
   without JavaScript (or with a failing Intl) there is no empty row. */
(function () {
  if (customElements.get('lt-delivery-estimate')) return;

  var DAY = 86400000;

  function isWeekend(date) {
    var day = date.getUTCDay();
    return day === 0 || day === 6;
  }

  function addBusinessDays(date, count) {
    var time = date.getTime();
    var left = count;
    while (left > 0) {
      time += DAY;
      if (!isWeekend(new Date(time))) left -= 1;
    }
    return new Date(time);
  }

  /* Today's date and hour in Warsaw, as a UTC midnight plus the hour. */
  function warsawNow() {
    var parts = {};
    new Intl.DateTimeFormat('en-US', {
      timeZone: 'Europe/Warsaw',
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      hourCycle: 'h23'
    }).formatToParts(new Date()).forEach(function (part) {
      parts[part.type] = part.value;
    });
    return {
      date: new Date(Date.UTC(+parts.year, +parts.month - 1, +parts.day)),
      hour: +parts.hour
    };
  }

  function formatter(locale) {
    var options = { month: 'short', day: 'numeric', timeZone: 'UTC' };
    try {
      return new Intl.DateTimeFormat(locale, options);
    } catch (error) {
      return new Intl.DateTimeFormat(undefined, options);
    }
  }

  class LtDeliveryEstimate extends HTMLElement {
    connectedCallback() {
      var min = parseInt(this.dataset.minDays, 10);
      var max = parseInt(this.dataset.maxDays, 10);
      var cutoff = parseInt(this.dataset.cutoffHour, 10);
      var template = this.dataset.template || '';
      var text = this.querySelector('[data-delivery-text]');
      if (!text || !template || isNaN(min) || isNaN(max) || isNaN(cutoff)) return;
      if (max < min) max = min;

      try {
        var now = warsawNow();
        var start = now.date;
        if (isWeekend(start) || now.hour >= cutoff) start = addBusinessDays(start, 1);
        var from = addBusinessDays(start, min);
        var to = addBusinessDays(start, max);
        var format = formatter(this.dataset.locale);
        var dates = typeof format.formatRange === 'function'
          ? format.formatRange(from, to)
          : format.format(from) + ' – ' + format.format(to);
        text.textContent = template.replace('[dates]', dates);
        this.hidden = false;
      } catch (error) {
        // Leave the row hidden rather than show a wrong or half-built date.
      }
    }
  }

  customElements.define('lt-delivery-estimate', LtDeliveryEstimate);
})();
